module.exports = __webpack_public_path__ + "img/CLOSED.660ba2ca.svg";